// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"2c4a8d31","58":"79a56aec","812":"f3f4d93a","963":"0b5e6c7c"}[chunkId] + ".chunk.js";
};